// -- React Libraries
import React from 'react';

// -- Libraries
import axios from 'axios';
import { Link } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';

// -- Variables
import API_URL from '../../../constants/server';

// -- Components
import CampaignDashboard from "../CampaignDashboard/index";
import CampaignState from "../CampaignState/index";

// -- Resources
import FlagAU from "../../../image/flags/AU.png";
import FlagCA from "../../../image/flags/Canada.png";
import FlagCH from "../../../image/flags/CH.png";
import FlagGB from "../../../image/flags/GB.png";
import FlagMX from "../../../image/flags/MX.png";
import FlagNZ from "../../../image/flags/NZ.png";
import FlagUS from "../../../image/flags/US.png";

// -- Styles
import StyleWrapper from "./Wrapper";

async function _getPerformances (authHeader, campaign) {
    let performances = [];
    let endDate = moment();//.format('YYYY-MM-DD');
    let startDate = moment(endDate).subtract(20, 'days');

    const performanceMap = await Promise.all(campaign.performanceByRegion.map( async (region) => {
        let reportResponse, totalData;
        
        if ( region.campaignId ) {
            try {
                reportResponse = await axios.get(`${API_URL}/user/campaigns/cid/${region.campaignId}/adgroups/rowtotals/${startDate.format('YYYY-MM-DD')}/${endDate.format('YYYY-MM-DD')}`, { headers: { 'Authorization': authHeader } } );
                if ( reportResponse.data.response.pagination.totalResults  > 0 ) {
                    totalData = reportResponse.data.response.data.reportingDataResponse.row[0];
                }
                
                console.log( '[CampaignItem][AdGroups] ', region.campaignId, reportResponse.data.response);
            } catch (error) {
                console.log( '[CampaignItem][AdGroups] ', region.campaignId, error);
            }
        }
        
        //get p cid to check status : RUNNING / NOT_RUNNING
        let searchadsCampaign;
        try {
            const response = await axios.get(`${API_URL}/user/campaigns/cid/${region.campaignId}`, { headers: { 'Authorization': authHeader } } );
            console.log( '[CampaignItem][Detail] ', response.data.response.data); // error is not defined
            searchadsCampaign = response.data.response.data;
        } catch (error) {
            console.log( '[CampaignItem][Detail] ', error); // error is not defined
        }
        
        return {
            appId: campaign.appId, //primary id
            region: region.region,
            pCid: region.campaignId,
            pReportAdGroup: reportResponse.data.response,
            pTotalData: totalData,
            emAdGroupId: region.emAdGroupId,
            key: campaign.appId + region.region,
            servingStatus: searchadsCampaign.servingStatus,
            appNamePrefix: `DEV-${campaign.shortId}-${campaign.appId}`
        };
    }));
    
    const discoveryMap = await Promise.all(campaign.discoveryByRegion.map( async(region) => {
        let reportResponse, totalData;
        if ( region.campaignId ){
            try {
                reportResponse = await axios.get(`${API_URL}/user/campaigns/cid/${region.campaignId}/adgroups/rowtotals/${startDate.format('YYYY-MM-DD')}/${endDate.format('YYYY-MM-DD')}`, { headers: { 'Authorization': authHeader } } );
                if ( reportResponse.data.response.pagination.totalResults  > 0 ) {
                    totalData = reportResponse.data.response.data.reportingDataResponse.row[0];
                }
                console.log( '[CampaignItem][AdGroups] ', region.campaignId,  reportResponse.data);
            } catch (error) {
                console.log( '[CampaignItem][AdGroups] ', region.campaignId, error);
            }
        }
        
        return {
            appId: campaign.appId, //primary id
            region: region.region,
            dCid: region.campaignId,
            dReportAdGroup: reportResponse.data.response,
            dTotalData: totalData,
            smAdGroupId: region.smAdGroupId,
            bmAdGroupId: region.bmAdGroupId
        };
    }));
    
    let campaignMapForAppId = _.map(performanceMap, obj => {
        return _.assign(obj, _.find(discoveryMap, {
            appId: obj.appId,
            region: obj.region
        }));
    });
    
    return campaignMapForAppId;
}

export default class CampaignItem extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = { isShowDetails: false, isHidden: false };

        this.AuthHeader = this.props.authHeader || '';
        this.AppID = props.campaign.appId;
        this.RegionalCampaigns = props.campaign.discoveryByRegion.map( (region) => {
            return { region: region.region, campaignID: region.campaignId, performance: null }
        });

        this.setState( {
            appItem: null,
            performances: null
        });

        this._getItunesStoreData(this.AppID, -1);
        this._getPerformances();
    }

    async _getItunesStoreData( appId, storeIndex ){
        if (storeIndex >= this.RegionalCampaigns.length) return;
        
        var countryCode = storeIndex >= 0 &&
            this.RegionalCampaigns[storeIndex].region || null;
        let Results = null;

        try {
            const response = countryCode &&
                await axios.post('https://itunes.apple.com/lookup', {}, { params: { id : appId, 'Authorization': this.AuthHeader, country: countryCode } }) ||
                await axios.post('https://itunes.apple.com/lookup', {}, { params: { id : appId, 'Authorization': this.AuthHeader } });
        
            Results = response && response.data && response.data.results || null;
        } catch (error) {
            console.log( '[CampaignItem][iTunesStore] ', error); // error is not defined
        }

        if (!Results || Results.length <= 0) {
            this._getItunesStoreData(appId, countryCode && (storeIndex + 1) || 0);
            return;
        }
        
        this.setState( { appItem: Results[0] } );
    }

    async _getPerformances() {
        var Performances = await _getPerformances(this.AuthHeader, this.props.campaign);
        this.setState( {
            performances: Performances,
            isHidden: Performances.length <= 0
        } );
    }

    render() {
        /**
         * using third party lib instead , dun use any asset image anymore
         */
        const _Flags = {
            "AU": FlagAU,
            "CA": FlagCA,
            "CH": FlagCH,
            "US": FlagUS,
            "GB": FlagGB,
            "MX": FlagMX,
            "NZ": FlagNZ
        };

        const _CountriesName = {
            "AU": "澳大利亚",
            "CA": "加拿大",
            "CH": "瑞士",
            "US": "美国",
            "GB": "英国",
            "MX": "墨西哥",
            "NZ": "新西兰"
        };

        const _changeState = function (countryCode, isSwitchingOn) {
            let Performances = this.state.performances;
            let Status = isSwitchingOn ? "ENABLED" : "PAUSED";

            this.setState({ performances: null} );
            
            console.log("[ChangeState] ", { countryCode: countryCode, isTurnOn: isSwitchingOn});
            // If no country code then apply to all countries, otherwise apply to the selected country only
            Performances.map( async (performance) => {
                if (!countryCode || performance.region == countryCode) {
                    let IsRunning = performance.servingStatus === "RUNNING";
                    if (IsRunning === isSwitchingOn) return;
                    
                    console.table(performance); //return;

                    const CampaignIDs = [performance.pCid, performance.dCid];
                    const request = {
                        campaign: {
                            status: Status,
                        }
                        // Whether user intends to run this campaign/adgroup or not. ENABLED, PAUSED
                    };
                    await Promise.all(CampaignIDs.map( async (cid) => {
                        let requestResponse;
                        try {
                            requestResponse = await axios.post(`${API_URL}/user/campaigns/cid/${cid}`, request, { headers: { 'Authorization': this.AuthHeader } } );
                            
                            const updatedCampaign = requestResponse.data.response.data;
                            console.log( '[CampaignItem][ChangeState] ', cid,  updatedCampaign);
                        } catch (error) {
                            console.error('[CampaignItem][ChangeState] ', cid, error);
                        }
                    }));
                }
            });

            this._getPerformances();
        }.bind(this);

        const _getFlag = function (countryCode) {
            return (countryCode && _Flags[countryCode]) && (
                <img src={_Flags[countryCode]} />
            ) || (<span></span>);
        }

        const _getCountryName = function (countryCode) {
            return (countryCode && _CountriesName[countryCode]) && (
                _CountriesName[countryCode]
            ) || ('');
        }

        return (
            <StyleWrapper key={this.props.campaign.appId} style={ this.state.isHidden && { display: 'none'} || {} }>
                {
                    (!this.state.appItem || !this.state.performances) && (
                        <div className="loading-overlay"></div>
                    )
                }
                
                <div className="row-wrapper">
                    {
                        this.state.appItem && (
                            <Link
                                to={`/dashboard/${this.AppID}` }
                            >
                                <dl className="app-header">
                                    <dt>
                                        <img src={ this.state.appItem.artworkUrl100} alt="screen"/>
                                    </dt>
                                    
                                    <dd>
                                        <span className="app-name">{ this.state.appItem.trackCensoredName }</span>
                                        <span className="app-desc">{ this.state.appItem.sellerName }</span>
                                    </dd>
                                </dl>

                                {
                                    this.state.performances && (
                                        <CampaignDashboard data={this.state.performances} />
                                    )
                                }
                            </Link>
                        )
                    }

                    {
                        this.state.performances && (
                            <CampaignState
                                id={this.AppID}
                                data={this.state.performances}
                                onChange={_changeState}
                            />
                        )
                    }
                </div>

                {
                    !this.state.performances && (
                        <div className="loading-word">载入中...</div>
                    ) || (
                        <div className="breakdowns">
                            {
                                !this.state.isShowDetails && (
                                    <button onClick={ () => { this.setState({isShowDetails: true});  } }>
                                        展开
                                    </button>
                                ) || (
                                    <ul>
                                        {
                                            this.state.performances.map((data) => {
                                                return (
                                                    <li key={ `campaign-${data.dCid}` }>
                                                        <div className="region-description">
                                                            {_getFlag(data.region)}
                                                            {_getCountryName(data.region)}
                                                        </div>

                                                        <CampaignDashboard data={data} className="breakdown"/>
                                                        <CampaignState
                                                            id={data.dCid}
                                                            region={data.region}
                                                            data={data}
                                                            onChange={_changeState}
                                                            className="breakdown"
                                                        />
                                                    </li>
                                                );
                                            })
                                        }
                                    </ul>
                                )
                            }

                            {
                                this.state.isShowDetails && (
                                    <button onClick={ () => { this.setState({isShowDetails: false}) } }>
                                        收起
                                    </button>
                                )
                            }
                        </div>
                    )
                }
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/CampaignList/CampaignItem/index.js